import { Module } from '../Module';

export interface TopBarSettings {
  collapsed: boolean;
  height: number;
}

export enum TopBarEvents {
  HeightChanged = 'HeightChanged',
  ToggleCollapse = 'ToggleCollapse',
  OpenSearch = 'OpenSearch'
}

export class TopBarService {

  private collapsed = false;

  public TopBarSettings: TopBarSettings = {
    collapsed: false,
    height: null
  };

  public static $inject = [
    '$rootScope',
  ];

  public constructor(
    private $rootScope: ng.IRootScopeService
  ) { }

  public isCollapsed() {
    return this.collapsed;
  }

  public toggle() {
    this.collapsed = !this.collapsed;
    this.$rootScope.$emit(TopBarEvents.ToggleCollapse);
  }

  public openSearch() {
    this.$rootScope.$emit(TopBarEvents.OpenSearch);
  }

}

Module.instance().service('TopBarService', TopBarService);
